module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/019-6b24007920887c54ca5738d3ec736ccf.jpg";